import { adviceI18nKeyTemplate } from './advice-i18n-keys';
import { I18nKeys } from './i18n-keys';

export function aiValidationI18nKeyTemplate(): I18nKeys['aiValidation'] {
  return {
    remove: '',
    quality: '',
    detection: '',
    warnings: '',
    dimensions: '',
    overallScore: '',
    sharpness: '',
    exposure: '',
    resolution: '',
    issues: '',
    equipmentType: '',
    confidence: '',
    boundingBoxes: '',
    show: '',
    hide: '',
    showBoundingBoxes: '',
    hideBoundingBoxes: '',
    imageSize: '',
    sourceSize: '',
    validationSuccessful: '',
    qualityIssues: '',
    lowConfidence: '',
    wrongEquipment: '',
    noDetection: '',
    validating: '',
    validationFailed: '',
    imageValidationSuccessful: '',
    imageQualityIssues: '',
    lowConfidenceDetection: '',
    wrongEquipmentDetected: '',
    noEquipmentDetected: '',
    imageValidationInProgress: '',
    imageValidationFailed: '',
    equipmentDetectedSuccessfully: '',
    imageTooLowQuality: '',
    equipmentDetectedLowConfidence: '',
    noEquipmentInImage: '',
    analyzingImage: '',
    validationFailedMessage: '',
    qualityCheckingImage: '',
    equipmentFound: '',
    qualityTooLowMessage: '',
    lowConfidenceMessage: '',
    noEquipmentDetectedMessage: '',
    validationFailedFor: '',
    confidenceWarning: '',
    reassuranceMessage: '',
    qualityIssuesLabel: '',
    detectionIssuesLabel: '',
    fuseCutout: '',
    consumerUnit: '',
    isolatorSwitch: '',
    unknown: '',
    equipment: '',
    failedToValidateImage: '',
    advice: adviceI18nKeyTemplate()
  };
}
